import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useRequiredAuth } from "../../common/guard/requiredAuth";
export const routers = [
  {
    name: "In-progress",
    path: "/recruitment/reports",
    to: "/recruitment/reports/in-progress",
    permissions: [
      "IS_HR",
      "IS_CBM",
      "IS_DAF",
      "IS_NPSC",
      "IS_NPSC_APPROVER",
      "IS_NPSC_SUPERVISOR",
      "IS_RECRUITMENT_MEMBER",
      "IS_RDB_SECOND_LEVEL",
      "IS_HEAD_OF_INSTITUTION",
      "IS_HEAD_OF_INSTITUTION_ACTING",
    ],
  },
  {
    name: "Assigned",
    path: "/recruitment/reports",
    to: "/recruitment/reports/assigned",
    permissions: ["IS_NPSC_SUPERVISOR"],
  },
  {
    name: "Archived",
    path: "/recruitment/reports",
    to: "/recruitment/reports/archived",
    permissions: [
      "IS_HR",
      "IS_CBM",
      "IS_DAF",
      "IS_NPSC",
      "IS_NPSC_SUPERVISOR",
      "IS_NPSC_APPROVER",
      "IS_RECRUITMENT_MEMBER",
      "IS_RDB_SECOND_LEVEL",
      "IS_HEAD_OF_INSTITUTION",
      "IS_HEAD_OF_INSTITUTION_ACTING",
    ],
  },
];

const RecruitmentReportLeftSide = () => {
  const location = useLocation();
  const { hasPermissions } = useRequiredAuth();
  return (
    <>
      <div className="list-group mt-4 ml-3">
        {routers.map((router, index) => (
          <React.Fragment key={index + 1}>
            {hasPermissions(router.permissions) && (
              <Link
                style={{ textDecoration: "none", color: "#fff" }}
                to={router.to}
                className={`list-group-item list-group-item-action  ${
                  location.pathname.includes(router.to)
                    ? "active"
                    : "text-dark "
                }`}
              >
                <span className="text-truncate  menu-item">{router.name}</span>
              </Link>
            )}
          </React.Fragment>
        ))}
      </div>
    </>
  );
};

export default RecruitmentReportLeftSide;
